import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
/* © 2022 Promethean. All Rights Reserved.
 *
 * Unauthorized copying of this file or any part of this file
 * via any medium is strictly prohibited.
 */
import React, { useState } from 'react';
import classnames from 'classnames';
import { StyledTablePaginationItem } from './tablePaginationItemStyles';
import { useIntl } from 'react-intl';
export var EmbersTablePaginationItem = function EmbersTablePaginationItem(props) {
  var intl = useIntl();
  var page = props.page,
    onClick = props.onClick,
    active = props.active;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    clickFocus = _useState2[0],
    setClickFocus = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    itemHasFocus = _useState4[0],
    setItemHasFocus = _useState4[1];
  var handleMouseDown = function handleMouseDown() {
    setClickFocus(true);
  };
  var handleClick = function handleClick() {
    if (onClick) {
      onClick(page);
    }
  };
  var handleBlur = function handleBlur(fEvt) {
    if ((fEvt === null || fEvt === void 0 ? void 0 : fEvt.relatedTarget) !== null) {
      setClickFocus(false);
      setItemHasFocus(false);
    }
  };
  var handleFocus = function handleFocus(fEvt) {
    setItemHasFocus(true);
  };
  var handleKeyUp = function handleKeyUp(e) {
    if (itemHasFocus && !clickFocus) {
      switch (e.key) {
        case ' ':
        case 'Enter':
          e.stopPropagation();
          handleClick();
          break;
        default:
          break;
      }
    }
  };
  return /*#__PURE__*/React.createElement(StyledTablePaginationItem, {
    className: classnames('EmbersTablePaginationItem-root', {
      'EmbersTablePaginationItem-selected': active,
      'EmbersTablePaginationItem-clickFocus': clickFocus
    }),
    onKeyUp: handleKeyUp,
    onMouseDown: handleMouseDown,
    onClick: handleClick,
    onFocus: handleFocus,
    onBlur: handleBlur,
    tabIndex: active ? -1 : 0,
    role: "button",
    "aria-current": active,
    "aria-label": intl.formatMessage({
      id: 'embers.table.pagination.numbered',
      defaultMessage: 'Page {number}'
    }, {
      number: page
    })
  }, page);
};